import { Box, Flex, HStack, Text } from '@chakra-ui/react'
import { CustomHeading } from 'components/ui/customHeading'
import { FC, ReactNode } from 'react'

type Props = {
  title: string
  description?: string
  action?: ReactNode
}

export const TopSectionHeader: FC<Props> = ({ title, description, action }) => (
  <Flex align="center" justify="space-between" gap="24px" pb="12px" borderBottomWidth="2px" borderColor="secondary">
    <HStack align="baseline" spacing="12px" minW={0}>
      <CustomHeading as="h4" flexShrink={0}>
        {title}
      </CustomHeading>
      {description && <Text color="gray.600">{description}</Text>}
    </HStack>
    {action && <Box flexShrink={0}>{action}</Box>}
  </Flex>
)
